export default __webpack_public_path__ + "static/media/runningMeasureMb4.cbe66356.png";